import {FunctionComponent} from 'react';
import * as React from 'react';
import {ModalComponentProps, Dialog, DialogBody, Title, Spinner, DialogFooter} from '@mc/ui-v4';

type Props = {
    className?: string;
    title?: string;
} & ModalComponentProps;

export const ApiCallWaitingModal: FunctionComponent<Props> = ({className, children, title = 'Probíhá zpracování požadované akce'}) => {
    return (
        <Dialog portalClassName={className} size={'md'}>
            <DialogBody disableScroll className={'flex-column'}>
                <Title type={'block'} className={'mt-3 text-center d-flex justify-content-center'}>
                    {title}
                </Title>
                <Spinner className={'mt-3'} />
                {children && <div className={'mt-3'}>{children}</div>}
            </DialogBody>
            <DialogFooter />
        </Dialog>
    );
};
